import $ from 'jquery';
const showKnowledge = ( letter = '', directTitle = '') =>{
    if(directTitle !== ''){
        showKnowledgePost(directTitle, letter);
        return;
    }
    const data = {
        action: 'get_knowledge',
        ume_nonce: wp_environment.ume_nonce,
        letter: letter,



    };
    $.post(wp_environment.ume_ajax_url, data, function (response) {

        if (response) {

            $('.ume-knowledge-holder').html('');
            $('.ume-knowledge-holder').append(response);
        }

    })


}
const showKnowledgePost = (  post , letter = '') =>{

    const data = {
        action: 'get_knowledge_post',
        ume_nonce: wp_environment.ume_nonce,
        post: post,
        letter: letter,



    };
    $.post(wp_environment.ume_ajax_url, data, function (response) {

        if (response) {

            $('.ume-knowledge-holder').html('');
            $('.ume-knowledge-holder').append(response);
        }

    })


}
$(document).ready(function () {
    if (document.querySelector('.ume-knowledge-holder')) {
        let holder = document.querySelector('.ume-knowledge-holder');
        let letter = holder.getAttribute('data-active-letter' );
        showKnowledge(letter);

    }

    $(document).on('click', '.ume-knowledge-letter-select-button', (event) =>{

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }

        let theYear = event.target.innerHTML;
        let parent = event.target.closest('.ume-knowledge-holder');
        parent.setAttribute('data-active-letter', theYear );

        showKnowledge(theYear);

    })
    $(document).on('click', '.ume-knowledge-load-post', (event) =>{

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }

        let post = event.target.innerHTML;
        let parent = event.target.closest('.ume-knowledge-holder');
        let letter = parent.getAttribute('data-active-letter' );
        parent.setAttribute('data-active-letter', '' );

        showKnowledgePost(post, letter);

    })
    $(document).on('click', '.ume-knowledge-back-to-filter', (event) =>{

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }
       let setLetter =  event.target.getAttribute('data-selected-letter');



        showKnowledge(setLetter);

    })
    $(document).on('click', '.ume-knowledge-letter-reset-button', (event) =>{

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }




        showKnowledge();

    })

});
export default showKnowledge;